import React from "react";
import PropTypes from "prop-types";
import AddToBagButtonWrapper from "components/source/reservations/add-to-bag-button-wrapper";
import ItemUnavailable from "components/source/reservations/item-unavailable";
import { browserPropType } from "components/propTypes";

class PDPSubmitActionsWrapper extends React.Component {
  static propTypes = {
    browser: browserPropType,
    isBulk: PropTypes.bool,
    isClearance: PropTypes.bool,
    isExistingHold: PropTypes.bool,
    isOneSize: PropTypes.bool.isRequired,
    isRentable: PropTypes.bool,
    price: PropTypes.shape({
      minimumFormatted: PropTypes.string,
      maximumFormatted: PropTypes.string,
    }),
    productId: PropTypes.string.isRequired,
    remaining: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectedSku: PropTypes.shape({
      size: PropTypes.string,
    }),
  };

  static defaultProps = {
    isSubmitting: false,
    isExistingHold: false,
    browser: {
      isMobileViewport: true, // especially for the moment when we aren't always getting this prop
    },
  };

  componentToRender = () => {
    const { remaining } = this.props;
    if (typeof remaining !== "number" || remaining > 0) {
      return (
        <AddToBagButtonWrapper
          isBulk={this.props.isBulk}
          isClearance={this.props.isClearance}
          isMobile={this.props.browser.isMobileViewport}
          isOneSize={this.props.isOneSize}
          isRentable={this.props.isRentable}
          price={this.props.price}
          isExistingHold={this.props.isExistingHold}
        />
      );
    } else {
      return <ItemUnavailable sku={this.props.selectedSku} id={this.props.productId} remaining={remaining} />;
    }
  };

  render() {
    return this.componentToRender();
  }
}

export default PDPSubmitActionsWrapper;
